// --- Our Modules --------------------------------------------------------------------------------
import constants from "@/config/constants";

// --- Constants ----------------------------------------------------------------------------------

/** Mirrors the backend's CLARITY_PROJECT_IDS — this app's own project, not the website's or a menu's. */
const CLARITY_PROJECT_ID = "yxkz9saaeg";

/** Mirrors the backend's NON_PRODUCTION_SUBDOMAINS. */
const NON_PRODUCTION_SUBDOMAINS = ["staging", "stage", "dev", "test", "preview", "demo", "local"];

// --- Logic --------------------------------------------------------------------------------------

/**
 * Whether this page is real public traffic, and therefore worth reporting.
 *
 * Gated twice, the same way the backend gates its own tags. A dev build never reports, and neither
 * does a production build served from anywhere but the live host — a staging deployment is built in
 * production mode too, and its sessions cannot be cleaned out of Clarity afterwards.
 */
const isLiveHost = (): boolean => {
    if (!import.meta.env.PROD) return false;

    const labels = window.location.hostname.toLowerCase().split(".");
    // `app.menuket.net` — one subdomain of the production domain, and not a reserved one.
    if (labels.slice(-2).join(".") !== constants.menuDomain) return false;
    if (labels.length !== 3) return false;

    return !NON_PRODUCTION_SUBDOMAINS.includes(labels[0]);
};

/**
 * Loads Microsoft Clarity, once, after boot.
 *
 * Injected from here rather than written into `index.html` because the tag must not run in dev or on
 * staging, and a script tag in the document has no way to ask which of those it is.
 */
export const startAnalytics = (): void => {
    if (!isLiveHost()) return;

    (function (c: any, l: Document, a: string, r: string, i: string) {
        c[a] =
            c[a] ||
            function (...args: unknown[]) {
                (c[a].q = c[a].q || []).push(args);
            };
        const t = l.createElement(r) as HTMLScriptElement;
        t.async = true;
        t.src = "https://www.clarity.ms/tag/" + i;
        const y = l.getElementsByTagName(r)[0];
        y.parentNode?.insertBefore(t, y);
    })(window, document, "clarity", "script", CLARITY_PROJECT_ID);
};
